<div class="container">
	<div class="card">
		<div class="card-header">{{ 'DETAILS' | translate }}</div>
		<div class="card-body">
			<div *ngFor="let row of chunkedFields" class="row mb-2">
				<ng-container *ngFor="let item of row">
					<div class="col-3 title">{{ item.field.field }}</div>
					<div class="col-3" *ngIf="item.field.inputField !== 'date'">{{util.parsePossibleBoolean(item.field.value)}}</div>
					<div class="col-3" *ngIf="item.field.inputField === 'date'">{{util.parseDate(item.field.value)}}</div>
				</ng-container>
			</div>
		</div>
	</div>
	<!-- <div class="row" *ngFor="let text of texts">
		<div class="col" *ngFor="let card of text.data.cards">
			<div class="card">
				<div class="card-header">{{card.card}}</div>
				<div class="card-body">
					<div class="row" *ngFor="let field of card.fields">
						<div class="col title">{{field.field}}</div>
						<div class="col" *ngIf="field.inputField !== 'date'">{{field.value}}</div>
						<div class="col" *ngIf="field.inputField === 'date'">{{util.parseDate(field.value)}}</div>
					</div>
				</div>
			</div>
		</div>
	</div> -->
	<div class="row" *ngFor="let image of images">
		<div class="col">
			<div class="card">
				<div class="card-header">{{ 'DOCUMENTS' | translate }}</div>
				<div class="card-body">
					<div class="row mb-2">
						<div class="col">{{image.field.field}}</div>
						<div class="col"><img [src]="getImageUrl(image.field.formControl.value)" alt="Preview" /></div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="row button-row">
		<div class="col">
			<button type="button" class="btn btn-primary float-end" (click)="previousStep()">{{'BACK' | translate}}</button>
		</div>
		<div class="col">
			<button type="button" class="btn btn-primary float-start" (click)="nextStep()">{{'NEXT' | translate}}</button>
		</div>
	</div>
</div>

